import * as React from 'react';
import * as moment from 'moment';
import Project from 'src/entities/Project';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';
import ImageContainer from 'src/modules/commons/images/Image.container';
import { Link } from 'react-router-dom';

export interface Props {
  project: Project;
}

const InterestedProjectCardComponent: React.StatelessComponent<Props> = (props: Props) => {

  let investedPercent: string;

  if (props.project.cashTarget === 0 ) {
    investedPercent = NumberFormater.percent(0);
  } else {
    investedPercent = NumberFormater.percent(props.project.cash / props.project.cashTarget, 0);
  }

  const cashTarget = NumberFormater.euros(props.project.cashTarget, 0);

  const remainingTime = Math.max(
    moment.utc(props.project.endDate, 'YYYY-MM-DD').diff(moment(new Date()), 'days'),
    0
  );

  return (
    <Link
      className="no-hover-card"
      to={'/ficha-de-operaciones/' + props.project.id}
    >
      <div className="col-sm-6 col-md-3">
        <div className="bk-grey-light-background padding-20">
          <p className="deco-title">
            <ImageContainer
              alt={props.project.company.name + ' logo'}
              className="img-responsive"
              url={props.project.company.logo}
              style={{margin: 'auto'}}
            />
          </p>
          <div className="gap-20"/>
          <p className="f-s-18">
            Tamaño de la ronda:<br/>
            <strong>{cashTarget}</strong>
          </p>
          <p className="f-s-18">
            % Comprometido:<br/>
            <strong>{investedPercent}</strong>
          </p>
          <p className="f-s-18">
            Días restantes:<br/>
            <strong>{remainingTime} días</strong>
          </p>
          <div className="gap-20"/>
          <Link
            to={'/ficha-de-operaciones/' + props.project.id}
            style={props.project.status === 'En financiación' ? {} : {visibility: 'hidden'}}
          >
            <button
              className="btn btn-secondary full-width"
            >
              Ver
            </button>
          </Link>
        </div>
        <div className="gap-20"/>
      </div>
    </Link>
  );
};

export default InterestedProjectCardComponent;



// WEBPACK FOOTER //
// ./src/modules/my-portfolio/partials/InterestedProjectCard.component.tsx